import { createSlice } from "@reduxjs/toolkit";

const initialAttorneyState = {
    searchResult: null,
    clearAsyncResults: false,
    firmLocationAttorneySelection: {
        law_firm_id: null,
        location_id: null,
        attorney_id: null
    },
    assignedAttorney: null,
    createdlocation: null,
    selectedProcoDocsAttorney: null
}

const attorneySlice = createSlice({
    name: 'attorney',
    initialState: initialAttorneyState,
    reducers: {
        setSearchResult(state, data) {
            state.searchResult = data.payload
        },
        setClearAsyncResults(state, data) {
            state.clearAsyncResults = data.payload
        },
        setFirmLocationAttorneySelection(state, data) {
            state.firmLocationAttorneySelection[data.payload.identifier] = data.payload.data
        },
        setFirmLocationAttorneySelectionIndividual(state, data) {
            state.firmLocationAttorneySelection[data.payload.identifier] = data.payload.data.value
        },
        removeFirmLocationAttorneySelection(state) {
            state.firmLocationAttorneySelection = {
                law_firm_id: null,
                location_id: null,
                attorney_id: null
            }
        },
        setAssignedAttorney(state, data) {
            state.assignedAttorney = []
            state.assignedAttorney.push(data.payload)
            // state.assignedAttorney = data.payload
        },
        removeAssignedAttorney(state) {
            state.assignedAttorney = null
        },
        setCreatedlocation(state, data) {
            state.createdlocation = data.payload
        },
        setSelectedProcoDocsAttorney(state, data) {
            state.selectedProcoDocsAttorney = data.payload
        },
        removeSelectedProcoDocsAttorney(state) {
            state.selectedProcoDocsAttorney = null
        }
    }
})

export const attorneyActions = attorneySlice.actions

export default attorneySlice.reducer